// src/components/NewCreateAppF/ChatModalOpenerPicker.js
import React from "react";

// Moved here verbatim from ThemeSettings — same preview HTML, same keys
export const CHAT_MODAL_STYLES = {
  default: {
    name: "Default Style",
    previewHtml: `<div style="background-color: rgb(163, 112, 206); display: inline-flex; align-items: center; justify-content: center; width: 50px; height: 50px; border-radius: 50%; position: relative; margin: 0 auto;"><i class="fas fa-comments" style="color: rgb(255, 255, 255); font-size: 24px;"></i><div style="position: absolute; top: -5px; right: -5px; background-color: red; color: rgb(255, 255, 255); border-radius: 50%; padding: 5px 10px; font-size: 12px;">0</div></div>`,
  },
  gradient_pulse: {
    name: "Gradient Pulse",
    previewHtml: `<div style="display: inline-flex; align-items: center; justify-content: center; width: 50px; height: 50px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 50%; cursor: pointer; box-shadow: 0 4px 15px rgba(0,0,0,0.2); transition: all 0.3s ease; animation: pulse 2s infinite; position: relative; margin: 0 auto;"><i class="fas fa-comment-dots" style="color: white; font-size: 24px;"></i><div style="position: absolute; top: -5px; right: -5px; background-color: #ff4757; color: white; border-radius: 50%; min-width: 22px; height: 22px; padding: 0 6px; font-size: 12px; font-weight: bold; display: flex; align-items: center; justify-content: center; border: 2px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.2);">0</div><style>@keyframes pulse { 0% { transform: scale(1); box-shadow: 0 4px 15px rgba(0,0,0,0.2); } 50% { transform: scale(1.05); box-shadow: 0 6px 20px rgba(102,126,234,0.4); } 100% { transform: scale(1); box-shadow: 0 4px 15px rgba(0,0,0,0.2); } }</style></div>`,
  },
  neomorphic_glass: {
    name: "Neomorphic Glass",
    previewHtml: `<div style="display: inline-flex; align-items: center; justify-content: center; width: 55px; height: 55px; background: rgba(255,255,255,0.25); backdrop-filter: blur(10px); border-radius: 15px; cursor: pointer; box-shadow: 8px 8px 16px rgba(0,0,0,0.1), -8px -8px 16px rgba(255,255,255,0.5); transition: all 0.3s ease; border: 1px solid rgba(255,255,255,0.3); position: relative; margin: 0 auto;"><i class="fas fa-headset" style="color: #5f27cd; font-size: 26px; text-shadow: 2px 2px 4px rgba(0,0,0,0.1);"></i><div style="position: absolute; top: -8px; right: -8px; background: linear-gradient(135deg, #ff6b6b, #ee5a24); color: white; border-radius: 50%; min-width: 22px; height: 22px; padding: 0 6px; font-size: 11px; font-weight: bold; display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255,255,255,0.8); box-shadow: 0 2px 10px rgba(0,0,0,0.2);">0</div></div>`,
  },
};

const ChatStylePreview = ({ styleKey }) => {
  const style = CHAT_MODAL_STYLES[styleKey];
  if (!style) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: style.previewHtml }} />
    </div>
  );
};

/**
 * Reusable Chat Modal Opener Themes picker.
 *
 * @param {string}   selectedStyle  - currently selected style key (e.g. "default")
 * @param {function} onStyleChange  - called with new style key when user picks one
 * @param {object}   styles         - CSS module (so both callers can keep their own modules)
 */
export default function ChatModalOpenerPicker({
  selectedStyle,
  onStyleChange,
  styles, // pass in LeadGenBotSettingStyle from the caller
}) {
  return (
    <div
      style={{
        marginBottom: "30px",
        padding: "20px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
      }}
      className={styles?.chatModalOpenerSty}
    >
      <h3 style={{ marginBottom: "15px", fontSize: "18px", fontWeight: "600" }}>
        Chat Modal Opener Themes
      </h3>
      <p style={{ marginBottom: "20px", color: "#666", fontSize: "14px" }}>
        Select an advanced theme for your chat modal opener button
      </p>

      <div className={styles?.modalOpener}>
        {Object.entries(CHAT_MODAL_STYLES).map(([key, style]) => (
          <div
            key={key}
            onClick={() => onStyleChange(key)}
            style={{
              cursor: "pointer",
              padding: "15px",
              border:
                selectedStyle === key
                  ? "2px solid #4CAF50"
                  : "1px solid #a3bdff",
              borderRadius: "8px",
              background: "#e6edff",
              transition: "all 0.3s ease",
              flex: "1 1 200px",
              textAlign: "center",
            }}
          >
            <div style={{ marginBottom: "10px", fontWeight: "500" }}>
              {style.name}
            </div>
            <div
              style={{
                height: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
              }}
            >
              <ChatStylePreview styleKey={key} />
            </div>
            {selectedStyle === key && (
              <div
                style={{
                  color: "#4CAF50",
                  fontSize: "12px",
                  marginTop: "8px",
                }}
              >
                ✓ Selected
              </div>
            )}
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "20px",
          padding: "15px",
          borderRadius: "6px",
          fontSize: "13px",
          color: "#1976d2",
          fontStyle: "italic",
        }}
      >
        <strong>Note:</strong> Selected theme will be saved as a flag. The
        client will render the appropriate chat opener based on this flag.
      </div>
    </div>
  );
}